'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const ChartInstantApyLoading = () => {
  return (
    <ChartCardLoading
      className="gap-sm"
      chartClassName="h-[230px] md:h-[224px]"
      titleClassName="w-[118px]"
      titleColumnClassName="gap-sm md:gap-xs"
      valueClassName="h-[44px] w-[110px]"
      controls={['h-8 w-[210px]']}
      mobileControls={['h-8 w-[94px]']}
    />
  )
}

export default memo(ChartInstantApyLoading)
